import { PaletteOptionsExtended } from "@mui/material/styles";

import { AssetColor } from "../enums/asset-color";

import { THEME_PRIMARY_MAIN_COLOR } from "./mui-theme-constants";

export const palette: PaletteOptionsExtended = {
  primary: {
    main: THEME_PRIMARY_MAIN_COLOR, // "#48AE4D"
    dark: "#208625",
    light: "#70D675",
    contrast: "#FFFFFF",
    hover: "#DAEFDB",
    selected: "#D1EBD3",
    focus: "#CAF3CC",
    focusVisible: "#A3D7A6",
    outlinedBorder: "#76C27A",
  },
  secondary: {
    main: "#024B24",
    dark: "#002D06",
    light: "#206942",
    contrast: "#FFFFFF",
  },
  info: {
    light: "#b9d8f1",
    main: "#5eb8ff",
    dark: "#5a8eb7",
    contrastText: "#ffffff",
  },
  error: {
    light: "#f88e86",
    main: "#f44336",
    dark: "#a2271e",
    contrastText: "#ffffff",
  },
  warning: {
    light: "#ffc166",
    main: "#ff9800",
    dark: "#bb7103",
    contrastText: "#ffffff",
  },
  success: {
    light: "#5aa257",
    main: "#82d87e",
    dark: "#b4e7b1",
    contrastText: "#ffffff",
  },
  text: {
    primary: "#464545",
    secondary: "#676767",
    disabled: "#a3a3a3",
  },
  background: {
    default: "#f5f5f5",
  },

  operationStatus: {
    done: "#82d87e",
    inProgress: "#ff9800",
    none: "#9e9e9e",
  },

  beta: {
    accent: "#208625",
    noticeBackground: "#eef8ea",
    noticeBorder: "#cfeac5",
    noticeText: "#33502a",
    noticeTitle: "#2a7d1c",
    noticeAction: "#5f7d55",
    chipBackground: "rgba(255, 255, 255, 0.94)",
    chipBorder: "#dfe2e6",
    chipLabel: "#55606a",
  },

  techopForm: {
    validStatusBackground: "#e8f5e9",
    validStatusIcon: "#2e7d32",
    invalidStatusBackground: "#fdecea",
    invalidStatusIcon: "#d32f2f",
    lockIcon: "#9e9e9e",
    restrictedValue: "#767676",
    restrictionAlertBackground: "#e5f6fd",
    restrictionAlertText: "#014361",
    cmaCardBorder: "#BDBDBD",
    cmaOrdinalBackground: "#EEEEEE",
    cmaOrdinalText: "rgba(0, 0, 0, 0.6)",
    restrictionAlertIcon: "#0288d1",
    removeIconDisabled: "#BDBDBD",
    tonalButtonDisabledBackground: "#E0E0E0",
    tonalButtonDisabledText: "#A6A6A6",
    headerHoverOverlay: "rgba(0, 0, 0, 0.04)",
    focusedCmaCardBorder: "#48AE4D",
    cmaTableHeaderDivider: "#EEEEEE",
    cmaTableRowDivider: "#F2F2F2",
  },

  dashedButton: {
    border: "#A5D6A7",
    hoverBorder: "#66BB6A",
    hoverBackground: "#F1F8F1",
    text: "#2E7D32",
    disabledBorder: "#BDBDBD",
    disabledText: "#A6A6A6",
  },

  techOperationGroupChip: {
    tillage: { text: "#c62828", background: "#ffebee" },
    sowing: { text: "#8a5a00", background: "#fae3c3" },
    spraying: { text: "#9a3fb0", background: "#ffe2ff" },
    fertilizing: { text: "#2e7d32", background: "#e8f5e9" },
    harvesting: { text: "#2f6496", background: "#d7e3ef" },
    others: { text: "#5f5f5f", background: "#eeeeee" },
  },

  techopList: {
    headerBackground: "#ffffff",
    headerText: "#212121",
    headerBottomBorder: "#d0d0d0",
    cellBorder: "#e0e0e0",
    rowZebraBackground: "#fafafa",
    loadingBackdrop: "rgba(255, 255, 255, 0.7)",
    inactiveSortIcon: "#9e9e9e",
    activeSortIcon: "#212121",
    rowActionBackground: "#ffffff",
    rowActionBorder: "#e0e0e0",
    editIcon: "#43a047",
    deleteIcon: "#e53935",
  },

  operationModeToggle: {
    surface: "#ffffff",
    border: "#cfd4d9",
    trackBackground: "#edeff2",
    activeLabel: "#23272c",
    inactiveLabel: "#656b72",
    exitIcon: "#3f454d",
    exitBorder: "#7c838b",
  },

  [AssetColor.AssetSeed]: {
    light: "#FBFEF7",
    main: "#FBFEF7",
    dark: "#FBFEF7",
    contrastText: "#000000",
  },
  [AssetColor.AssetFertiliser]: {
    light: "#F4FAFD",
    main: "#F4FAFD",
    dark: "#F4FAFD",
    contrastText: "#000000",
  },
  [AssetColor.AssetChemical]: {
    light: "#FFF8F4",
    main: "#FFF8F4",
    dark: "#FFF8F4",
    contrastText: "#000000",
  },
};
